import {Component, ContentChildren, Input, QueryList} from '@angular/core';
import {TabContentDirective} from "../../directives/tab-content.directive";

@Component({
    selector: 'shared-tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.css'],
    standalone: false
})
export class TabsComponent {
  @Input({required: true}) tabs: string[] = []
  @ContentChildren(TabContentDirective) content!: QueryList<TabContentDirective>

  get tabsContent() {
    const result = this.content.toArray()

    return result
  }

  setTab(number: number) {
    this.activeTab = number
  }

  activeTab = 0
}
